import classNames from "classnames";
import PropTypes from "prop-types";
import QRCode from "qrcode.react";
import React from "react";
import Slider from "react-slick";

class MediaMultiShare extends React.Component {
  render() {
    const slideSettings = {
      speed: 60000,
      autoplay: true,
      autoplaySpeed: 1000,
      cssEase: "linear",
      slidesToShow: 1,
      slidesToScroll: 1,
      variableWidth: true,
      appendArrows: false
    };

    if (this.props.preload === true) {
      slideSettings.autoplay = false;
    }

    const qrCodeClass = classNames("multi-share-link", {
      "hidden-qr": !this.props.displayQr
    });

    return (
      <div className="multi_share-container">
        <Slider {...slideSettings}>
          {this.props.media.map(function(subattachment, index) {
            return (
              <div key={index}>
                <img
                  src={subattachment.media.image.src}
                  alt={subattachment.title}
                />
                <div className="message">
                  <h3>{subattachment.title}</h3>
                </div>
              </div>
            );
          })}

          {this.props.displayQr && (
            <div className={qrCodeClass}>
              <QRCode value={this.props.post.link} level="L" />
              <div className="message">
                <h3>See more</h3>
              </div>
            </div>
          )}
        </Slider>
      </div>
    );
  }
}

MediaMultiShare.propTypes = {
  preload: PropTypes.bool,
  displayQr: PropTypes.bool,
  media: PropTypes.array,
  post: PropTypes.shape({
    attachments: PropTypes.arrayOf(
      PropTypes.shape({
        description: PropTypes.string,
        media: PropTypes.shape({
          image: PropTypes.shape({
            height: PropTypes.number,
            width: PropTypes.number,
            src: PropTypes.string
          })
        }),
        target: PropTypes.shape({
          url: PropTypes.string
        }),
        title: PropTypes.string,
        type: PropTypes.string,
        url: PropTypes.string
      })
    ),
    created_time: PropTypes.string,
    id: PropTypes.string,
    likes: PropTypes.shape({
      data: PropTypes.array,
      summary: PropTypes.object
    }),
    link: PropTypes.string,
    message: PropTypes.string
  })
};

export default MediaMultiShare;
